import { render, staticRenderFns } from "./PreApprovedOtGrid.vue?vue&type=template&id=1817f000"
import script from "./PreApprovedOtGrid.vue?vue&type=script&lang=js"
export * from "./PreApprovedOtGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports